import { render, staticRenderFns } from "./DeckGamesInfo.vue?vue&type=template&id=ab6bdb44&"
import script from "./DeckGamesInfo.vue?vue&type=script&lang=js&"
export * from "./DeckGamesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports